import { Component, Input, inject } from '@angular/core';
import { Tab } from '../../model/tabs';
import { LayoutTabContainerComponent } from '../layout-tab-container/layout-tab-container.component';

@Component({
  selector: 'app-layout-tab',
  templateUrl: './layout-tab.component.html',
  styleUrls: [ './layout-tab.component.scss' ],
  standalone: true
})
export class LayoutTabComponent {
  container = inject(LayoutTabContainerComponent);

  @Input() tab: Tab;

}
